import React from 'react';
import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import Reveal from '../../../shared/Reveal/Reveal';
import './Ecosystem.css';

const items = [
  {
    tagline: 'Stability & Security',
    title: 'Institutional-Grade Infrastructure',
    text: 'Discover how we build and maintain our core systems to ensure operational continuity, data security, and long-term resilience.',
    cta: 'Learn About Our Infrastructure',
    to: '/technology/infrastructure',
  },
  {
    tagline: 'Multi-Device Access',
    title: 'Advanced Trading Platforms',
    text: 'Access powerful, intuitive, and secure platforms available across desktop, web, and mobile, allowing you to stay connected from anywhere.',
    cta: 'Explore Our Platforms',
    to: '/technology/platforms',
  },
  {
    tagline: 'Uninterrupted Continuity',
    title: 'Continuous Connectivity (VPS)',
    text: 'Optimize your market presence with dedicated hosting environments designed for high-availability access and algorithmic stability.',
    cta: 'View Hosting Solutions',
    to: '/technology/vps-hosting',
  },
];

const Ecosystem = () => {
  return (
    <section className="technology-ecosystem">
      <div className="technology-ecosystem__inner">
        <Reveal>
          <h2 className="technology-ecosystem__title">Technology Ecosystem</h2>
        </Reveal>

        <div className="technology-ecosystem__grid">
          {items.map(({ tagline, title, text, cta, to }, index) => (
            <Reveal key={title} delay={index * 80}>
              <article className="technology-ecosystem__card">
                <div className="technology-ecosystem__card-top">
                  <p className="technology-ecosystem__tagline">{tagline}</p>
                  <h3 className="technology-ecosystem__card-title">{title}</h3>
                </div>

                <div className="technology-ecosystem__card-bottom">
                  <p className="technology-ecosystem__card-text">{text}</p>
                  <Link to={to} className="technology-ecosystem__card-link">
                    {cta}
                    <HiArrowRight
                      className="technology-ecosystem__card-link-icon"
                      aria-hidden="true"
                    />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;
